<template>
  <v-snackbar 
    :value="true" 
    timeout="-1" 
    bottom 
    :style="{ zIndex: 20000 }" 
    outlined 
    color="error" 
    class="snackbar_error"
  >
    <v-icon color="error">{{ mdiCloseCircleOutline }}</v-icon> The same link seems to have opened in another window. Please close this window.
  </v-snackbar>
</template>

<script>
import { mdiCloseCircleOutline } from '@mdi/js';

export default {
  name: 'ConnectionProblem',
  data() {
    return {
      mdiCloseCircleOutline
    }
  }
};
</script>

<style lang="scss">
  .v-snack {
    height: auto;
    top: auto;
  }
</style>
